// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25Wlx","left":"styles_left__c4dmG","right":"styles_right___BCk5","alert":"styles_alert__2KrpV"};